export function isValidYoutubeId(id: string) {
    return /[a-zA-Z0-9_-]{11}/.test(id);
}

export function getYoutubeIdFromUrl(url: string) {
    const parsedUrl = new URL(url);

    switch (parsedUrl.hostname) {
        case 'youtu.be':
            return parsedUrl.pathname.replaceAll(/^\//g, '');
        default:
            return (parsedUrl.hostname.includes('youtube') && parsedUrl.searchParams.get('v')) || '';
    }
}
